import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateUserWithRoleMutationVariables = Types.Exact<{
  user_name: Types.Scalars['String'];
  role: Types.Scalars['String'];
}>;


export type CreateUserWithRoleMutation = { __typename?: 'Mutation', createUserWithRole?: { __typename?: 'CreatedUserResponse', id: string, name: string, password: string } | null };


export const CreateUserWithRoleDocument = gql`
    mutation CreateUserWithRole($user_name: String!, $role: String!) {
  createUserWithRole(user_name: $user_name, role: $role) {
    id
    name
    password
  }
}
    `;
export type CreateUserWithRoleMutationFn = Apollo.MutationFunction<CreateUserWithRoleMutation, CreateUserWithRoleMutationVariables>;

/**
 * __useCreateUserWithRoleMutation__
 *
 * To run a mutation, you first call `useCreateUserWithRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserWithRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserWithRoleMutation, { data, loading, error }] = useCreateUserWithRoleMutation({
 *   variables: {
 *      user_name: // value for 'user_name'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCreateUserWithRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserWithRoleMutation, CreateUserWithRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserWithRoleMutation, CreateUserWithRoleMutationVariables>(CreateUserWithRoleDocument, options);
      }
export type CreateUserWithRoleMutationHookResult = ReturnType<typeof useCreateUserWithRoleMutation>;
export type CreateUserWithRoleMutationResult = Apollo.MutationResult<CreateUserWithRoleMutation>;
export type CreateUserWithRoleMutationOptions = Apollo.BaseMutationOptions<CreateUserWithRoleMutation, CreateUserWithRoleMutationVariables>;